import { api } from '../api';

// Get all published trips (only from approved hosts)
export const getPublishedTrips = async () => {
  const result = await api.getPublishedTrips();
  if (result.error) {
    throw new Error(result.error);
  }
  return result.data;
};

// Get trip by ID
export const getTrip = async (tripId) => {
  const result = await api.getTrip(tripId);
  if (result.error) {
    return null;
  }
  return result.data;
};

// Get trips by host
export const getHostTrips = async (hostId) => {
  const result = await api.getHostTrips(hostId);
  if (result.error) {
    throw new Error(result.error);
  }
  return result.data;
};

// Create trip (host only)
export const createTrip = async (tripData) => {
  const result = await api.createTrip(tripData);
  if (result.error) {
    throw new Error(result.error);
  }
  return result.data.id;
};

// Update trip (host only)
export const updateTrip = async (tripId, updates) => {
  const result = await api.updateTrip(tripId, updates);
  if (result.error) {
    throw new Error(result.error);
  }
};

// Publish trip (host can publish their own trips)
export const publishTrip = async (tripId) => {
  const result = await api.publishTrip(tripId);
  if (result.error) {
    throw new Error(result.error);
  }
};

// Unpublish trip (host can unpublish their own trips)
export const unpublishTrip = async (tripId) => {
  const result = await api.unpublishTrip(tripId);
  if (result.error) {
    throw new Error(result.error);
  }
};

// Delete trip (host can delete their own trips)
export const deleteTrip = async (tripId) => {
  const result = await api.deleteTrip(tripId);
  if (result.error) {
    throw new Error(result.error);
  }
};

